import PropTypes from 'prop-types';
import {Button} from '@gisatcz/ptr-atoms';
import {useState} from 'react';
import {GeonamesSearch} from '@gisatcz/ptr-components';

import './style.scss';

const SearchPlaceControl = ({setMapView}) => {
	const [searchBoxOpen, setSearchBoxOpen] = useState(false);

	return (
		<>
			<Button
				primary={searchBoxOpen}
				onClick={() => {
					setSearchBoxOpen(!searchBoxOpen);
				}}
				floating
				small
				icon="ri-location-search"
			>
				Search
			</Button>
			{searchBoxOpen ? (
				<GeonamesSearch
					autoFocus={true}
					maxPlaces={7}
					onPlaceSelect={setMapView}
					placeholder="Type location name..."
					hideClearIcon={true}
					className="unhab-GeonamesSearchBox"
				/>
			) : null}
		</>
	);
};

SearchPlaceControl.propTypes = {
	setMapView: PropTypes.func,
};

export default SearchPlaceControl;
